export const COMPETITION_TRACKED_PAGES = {
  COMPETITION_REGISTRATION_CONFIRMATION:
    'Registration for competition completed',
  COMPETITION_SUBMISSION_CONFIRMATION: 'Submission for competition completed',
}

export const COMPETITION_PROBLEM_STATES = [
  { label: 'All', value: 'all-problems' },
  { label: 'Solved', value: 'solved-problems' },
  { label: 'Partially solved', value: 'partially-solved-problems' },
  { label: 'Attempted', value: 'attempted-problems' },
  { label: 'Not attempted', value: 'not-attempted-problems' },
]

export const AUTH_MODAL_STATES = {
  OTP: 'otp',
  PHONE: 'phone',
}

export const COMPETITIONS_PHASES = {
  REGISTER: 'register',
  SUBMIT: 'submit',
}

export const COMPETITION_PHASE_TYPES = {
  HACKATHON: 'Hackathon',
  CODING_CONTEST: 'Coding contest',
} as const

export const PROBLEM_LIST_ITEMS = {
  ALL: 'All',
  INFO: 'Info',
}

export const EDITOR_LANGUAGE_ID_MAP = {
  PYTHON: {
    label: 'Python',
    value: 'python',
    id: 1,
  },
  C: {
    label: 'C',
    value: 'c',
    id: 2,
  },
  CPP: {
    label: 'C++',
    value: 'cpp',
    id: 3,
  },
  JAVA: {
    label: 'Java',
    value: 'java',
    id: 4,
  },
  JAVASCRIPT: {
    label: 'JavaScript',
    value: 'javascript',
    id: 5,
  },
}

export const EDITOR_THEMES = {
  LIGHT: {
    label: 'Light',
    value: 'light',
  },
  DARK: {
    label: 'Dark',
    value: 'vs-dark',
  },
  HIGH_CONTRAST: {
    label: 'High contrast',
    value: 'hc-black',
  },
}

export const SUBMISSION_POLLING_FINISHED_STATUSES = ['Completed', 'Aborted']

export const PROBLEM_PAGE_VIEWS = {
  PROBLEMS: { name: 'All Problems', value: 'problems' },
  SUBMISSIONS: { name: 'My Submissions', value: 'submissions' },
  LEADERBOARD: { name: 'Leaderboard', value: 'competition-leaderboard' },
}
